module.exports = __webpack_public_path__ + "img/image48.0857495a.webp";